import React, { useState } from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { PrimaryButton, SecondaryButton, SizeableRoundedDialog, Text, TextArea, TextButton } from 'library';
import { IShift, ShiftProviderUser } from 'models';
import { ILeanShift } from '../../BusinessJob/models';
import theme from 'theme';
import { client, consoleLogInDev } from 'shared';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

export default function RemoveProviderFromShfit({
    shift,
    provider,
    provider_id,
    setBanModal,
}: {
    provider: ShiftProviderUser;
    provider_id: number;
    shift: IShift | ILeanShift;
    setBanModal: (b: boolean) => void;
}) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const [cancelShiftModal, setCancelShiftModal] = useState(false);
    const [comments, setComments] = useState('');
    function removeProvider() {
        client('api/sub-shifts/remove-provider/', {
            body: {
                provider_id: provider_id,
                appointment_id: shift.id,
                comments,
            },
        })
            .then(() => setBanModal(true))
            .catch(consoleLogInDev)
            .finally(() => setCancelShiftModal(false));
    }

    return (
        <>
            <TextButton
                onClick={() => setCancelShiftModal(true)}
                textStyle={{ textDecoration: 'none' }}
                buttonStyle={{ justifyContent: 'flex-start' }}
            >
                <PersonRemoveIcon /> Remove {provider.first_name}
            </TextButton>
            <SizeableRoundedDialog
                style={{ maxWidth: small ? '100%' : '50%' }}
                open={cancelShiftModal}
                onClose={() => setCancelShiftModal(false)}
                title={``}
                closeButton
            >
                <Text textStyle={{ paddingLeft: 20 }} variant="display">
                    Remove {provider?.first_name} from this shift?
                </Text>
                <Grid item container direction="column" style={{ padding: 20, gap: 20 }}>
                    <Text variant="body1">
                        We will inform {provider?.first_name} that you no longer need them to work on this day. This
                        action will reopen the shift to be filled by a different provider. If you need to cancel the
                        shift completely, you can select{' '}
                        <Text inline bold>
                            Cancel this shift
                        </Text>{' '}
                        instead.
                    </Text>
                    <TextArea
                        style={{ width: '100%' }}
                        multiline
                        rows={5}
                        value={comments}
                        placeholder="Add any additional comments for The Tandem team"
                        onChange={(e) => setComments(e.target.value)}
                        inputProps={{ maxLength: 500 }}
                        helperText="Comments will only be seen by The Tandem Team. 500 Character limit."
                    />
                    <Grid item container direction="row" justify="flex-end" style={{ gap: 20 }}>
                        <SecondaryButton onClick={() => setCancelShiftModal(false)} buttonStyle={{ width: 'unset' }}>
                            Cancel
                        </SecondaryButton>
                        <PrimaryButton onClick={removeProvider} buttonStyle={{ width: 'unset' }}>
                            Confirm
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </SizeableRoundedDialog>
        </>
    );
}
